(function($) {
	'use strict';
	$.fn.DataUsage = function() {
		this.each(function() {

			/*
			 * Action: Add slide to collection
			 */
			var $self = $(this);
      
			// Listen for click
      if( 'storage' in navigator && 'estimate' in navigator.storage ) {

        navigator.storage.estimate().then( estimate => {
          //   console.log( 'Usage: ' + estimate.usage/10000000 + 'MB' );
          //   console.log( 'Quota: ' + estimate.quota/10000000000 + 'GB');
          console.log( '[DataUsage] Checked: ' + estimate.usage + ' of ' + estimate.quota + ' used.');

          if( estimate.quota - estimate.usage < 1000 ) {
            console.warn( 'Data Usage Warning: Too much saved offline.');
            $self.html( 'Note: You are close to or over your offline data max.' );
          }

        });

      }


		});
		return this;
	};
}(jQuery));
